import { render, staticRenderFns } from "./personal-settings-container.vue?vue&type=template&id=519f52d1"
import script from "./personal-settings-container.vue?vue&type=script&lang=js"
export * from "./personal-settings-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports